import {
  connectAcceptance,
  createIdLink,
  commonDictionaryFields,
} from './common';

import { defineColumns } from 'components/PageTable/defineColumns';

const config = {
  id: {
    sortable: true,
    className: 'id',
    getValue: createIdLink('item'),
    parser: ({ value }) => value === undefined ? '' : value,
  },
  type: {},
  version: {},
  itemUrl: { className: 'td400' },
  itemListCount: {},
  ...commonDictionaryFields,
};

export const columns = defineColumns(
  connectAcceptance(config, []),
);

export const defaultColumns = Object.keys(config).slice(1);

export const tableParams = { columns, defaultColumns, readOnly: true };

export default columns;
